import React from 'react';
import { ArrowRight } from 'lucide-react';
import "./Insights.css"
import headerImage from "../assets/Insights/freepik__adjust__79011.png"
import Navbar from '../comp/Navbar';
import Footer from '../comp/Footer';

const insightsData = [
  {
    id: 1,
    title: '(Part-1) Rethinking Finance Functions in High-Growth Companies',
    description: 'In early-stage ventures, the finance function must be fluid, lean, and deeply aligned with discovery. As a company matures into high-growth mode, the finance function must shift into a structured, ROI-driven engine',
    image: "https://img.freepik.com/free-photo/people-office-analyzing-checking-finance-graphs_23-2150377145.jpg?uid=R200293206&ga=GA1.1.1906576864.1747202384&semt=ais_hybrid&w=740",
    slug: 'rethinking-finance-part-1'
  },
  {
    id: 2,
    title: '(Part-2) Rethinking Finance Functions in High-Growth Companies',
    description: 'Years ago, I studied piano performance and pedagogy under Dr. Paul Pollei, a distinguished professor and founder of the Gina Bachauer International Piano Foundation',
    image: "https://images.unsplash.com/photo-1520523839897-bd0b52f945a0?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    slug: 'rethinking-finance-part-2'
  },
  {
    id: 3,
    title: '(Part-3) Rethinking Finance Functions in High-Growth Companies',
    description: "Don't Lock Yourself In Too Soon: Smart Finance Investments for Early-Stage and High-Growth Companies",
    image: "https://plus.unsplash.com/premium_photo-1661443781814-333019eaad2d?q=80&w=1251&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    slug: 'rethinking-finance-part-3'
  },
  // {
  //   id: 4,
  //   title: 'India\'s Next 75 Years – (Episode 1- EDUCATION)',
  //   description: 'August 14th 1947 – Panditji said in his midnight address about India\'s tryst with destiny and educational reforms...',
  //   image: "https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=800&q=80",
  //   slug: 'india-next-75-years-education'
  // },
];

const Insights = () => {
  const handleCardClick = (slug) => {
    // Navigate to the full insight page
    window.location.href = `/insights/${slug}`;
  };

  return (
    <>
    <Navbar/>
      <section
        className="insights-header"
        style={{
          backgroundImage: `url(${headerImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          padding: '80px 20px',
          marginTop: '25px',
          color: '#fff',
          position: 'relative',
        }}
      >
        <div className="overlay" style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
          zIndex: 0,
        }}></div>

        <div style={{ position: 'relative', zIndex: 1, maxWidth: '1200px', margin: '0 auto', textAlign: 'center' }}>
          <h3 style={{ 
            fontSize: '24px', 
            fontWeight: 'bold', 
            marginBottom: '20px',
            color: ' #34a853',
            textAlign:'left',
          }}
           data-aos="fade"
          data-aos-duration="700"
          data-aos-once="True"
          data-aos-delay="50">
         <b>Insights</b>
          </h3>
        
          <p style={{ 
            fontSize: '14px', 
            lineHeight: '1.6',
            maxWidth: '800px',
            
            opacity: 0.9,
            textAlign:'left',
          }}>
            Access strategic financial insights that inspire informed decision-making. Delve into our extensive repository of case studies, thought leadership articles, and market analyses.
          </p>
        </div>
      </section>
      
      {/* Featured Insights Section */}
      <section className="featured-insights-section">
        <div className="container">
          <h2 className="section-heading">Featured Insights</h2>
          <div className="insights-grid">
            {insightsData.map((item) => (
              <div 
                className="insight-card" 
                key={item.id}
                onClick={() => handleCardClick(item.slug)}
              >
                <div className="insight-image-container">
                  <img src={item.image} alt={item.title} className="insight-image" />
                  <div className="image-overlay"></div>
                </div>
                <div className="insight-content">
                  <h3 className="insight-title">{item.title}</h3>
                  <p className="insight-description">{item.description}</p>
                  <div className="read-more-container">
                    <button className="read-more">
                      <ArrowRight size={16} />
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <Footer/>
    </>
  );
};

export default Insights;
